module.exports = __webpack_public_path__ + "img/11_88.fbf42fab.png";